module.exports = __webpack_public_path__ + "img/eco-restaurant.814515be.png";